export default __webpack_public_path__ + "static/media/icon-coin-tru.ef3f3d27.svg";